
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.225 9.165a3.69 3.69 0 001.275-2.79 3.75 3.75 0 00-7.5 0 3.69 3.69 0 001.275 2.79 6 6 0 00-3.525 5.46.75.75 0 101.5 0 4.5 4.5 0 119 0 .75.75 0 101.5 0 6 6 0 00-3.525-5.46zm-2.475-.54a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zm7.305.24a3.75 3.75 0 00-2.805-6.24.75.75 0 100 1.5 2.25 2.25 0 012.25 2.25 2.25 2.25 0 01-1.125 1.943.75.75 0 00-.037 1.274l.292.195.097.053a5.25 5.25 0 013 4.785.75.75 0 101.5 0 6.75 6.75 0 00-3.172-5.76z"}})])
          )
        }
      }
    